// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"540e0da3","647":"788f0f45"}[chunkId] + ".chunk.js";
};